
import { mapGetters } from 'vuex'
import TopBanner from './plp-content/topBanner.vue'
import RelatedCategories from './relatedCategories.vue'

export default {
  components: {
    TopBanner,
    RelatedCategories,
  },
  data() {
    return {
      wording: null,
      breadcrumbWording: null,
      breadcrumb_1: null,
      breadcrumb_2: null,
      breadcrumb_3: null,
    }
  },
  computed: {
    ...mapGetters({
      vxMenuLvl2Flat: 'menu/getMenuLvl2Flattened',
      vxStoryContent: 'search/getStoryContent',
    }),
    breadcrumbs() {
      const bc = []
      if (this.breadcrumb_1) bc.push(this.breadcrumb_1.key)
      if (this.breadcrumb_2) bc.push(this.breadcrumb_2.key)
      if (this.breadcrumb_3) bc.push(this.breadcrumb_3.key)
      return bc
    },
  },
  beforeMount() {
    this.getBreadCrumbWording()
  },
  methods: {
    async getBreadCrumbWording() {
      try {
        const response = await this.$storyblok.getStory(
          '/common/breadcrumb-common'
        )
        this.breadcrumbWording = response.story.content

        // BREADCRUMBS LEVEL 3
        this.breadcrumb_3 = this.breadcrumbWording.level_3.find(
          (item) => this.$route.path.includes(item.link) || null
        )

        // BREADCRUMBS LEVEL 2
        if (this.breadcrumb_3) {
          this.breadcrumb_2 = this.breadcrumbWording.level_2.find(
            (item) => item.key === this.breadcrumb_3.parent_key
          )
        } else {
          this.breadcrumb_2 = this.breadcrumbWording.level_2.find(
            (item) => this.$route.path.includes(item.link) || null
          )
        }

        // BREADCRUMBS LEVEL 1
        if (this.breadcrumb_2) {
          this.breadcrumb_1 = this.breadcrumbWording.level_1.find(
            (item) => item.key === this.breadcrumb_2.parent_key
          )
        } else {
          this.breadcrumb_1 = this.breadcrumbWording.level_1.find(
            (item) => this.$route.path.includes(item.link) || null
          )
        }
      } catch (error) {
        this.$sentryException(error, {
          source: `PLP Breadcrumbs`,
          level: 'warning',
          extra: 'Failed to get the story from storyblok',
        })
      }
    },
  },
}
